import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { useLocation } from "react-router-dom";
import { Paper, Grid, FormGroup, Tooltip } from '@material-ui/core';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import Moment from "moment";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import { Link } from 'react-router-dom';
import CreateCustomerCompaints from '../../crm_service/CustomerCompaints/CreateCustomerCompaints';
import BiztranControls from "../../biztran_controls/BiztranControls";
import UseFetchData from "../../../hooks/UseFetchData";

const todate = new Date();
const fromdate = todate.getFullYear() - 1 + '/04/01';

const CustomerCompaints = () => {
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [Count, setCount] = useState('');
    const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    const [ComboSalesExecutive, setComboSalesExecutive] = useState([]);
    const [NcNumber, setNcNumber] = useState('');
    const [Customer, setCustomer] = useState('');
    const [Product, setProduct] = useState('');
    const [IssueTicketID, setIssueTicketID] = useState('');
    const [isOpen, setOpen] = useState(false);
    const [Mode, setMode] = useState('');
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [response, fetchData] = UseFetchData();


    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const openModal = (row) => {
        // debugger;
        setOpen(true);
        setIssueTicketID(row.id);
    };

    const handleOpenModal = () => {
        setIssueTicketID('');
        setMode('Insert');
        setOpen(true);
    };

    const PopulateData = () => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("SalesExecutiveID", SalesExecutiveID);
        bodyFormData.append("NcNumber", NcNumber);
        bodyFormData.append("Customer", Customer);
        bodyFormData.append("Product", Product);
        fetchData("CustomerCompaints/List", bodyFormData);
    };

    const GetComboData = () => {
        var bodyFormData = new FormData();
        fetchComboData("CustomerCompaints/ComboData", bodyFormData);
    };


    useEffect(() => {
        // debugger;
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["SalesExecutive"] !== undefined) {
                setComboSalesExecutive(ComboDataResponse["SalesExecutive"]);

            }
        }
    }, [ComboDataResponse]);


    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Edit</a> </strong>),
                // renderCell: (params) => (<strong> <a href="javascript:;"  onClick={() => { openModal(params.getValue("id")); }} >Edit</a> </strong> ), 
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "IssueTicketNo",
                headerName: "NC No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 130,
            },
            {
                field: "IssueTicketDate",
                headerName: "Ticket Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "CreatedBy",
                headerName: "Created By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "AccountName",
                headerName: "Account Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 240,
                renderCell: (params) => (
                    <Tooltip title={params.row.AccountName} >
                        <span className="table-cell-trucate">{params.row.AccountName}</span>
                    </Tooltip>
                )
            },
            {
                field: "ProductName",
                headerName: "Product Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
                renderCell: (params) => (
                    <Tooltip title={params.row.ProductName} >
                        <span className="table-cell-trucate">{params.row.ProductName}</span>
                    </Tooltip>
                )
            },
            {
                field: "ModelCode",
                headerName: "Model Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "FoundDuringDesc",
                headerName: "Description",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                // type: Text,
                width: 220,
                renderCell: (params) => (
                    <Tooltip title={params.row.FoundDuringDesc} >
                        <span className="table-cell-trucate">{params.row.FoundDuringDesc}</span>
                    </Tooltip>
                )
            },
            {
                field: "Qty",
                headerName: "Quantity",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "DrawingNumber",
                headerName: "Drawing No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            // {
            //     field: "RefNumber",
            //     headerName: "Ref No",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 160,
            // },
            {
                field: "ClosedBy",
                headerName: "Closed By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "DispositionOn",
                headerName: "Closed On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            }
        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
    }, [response]);

    useEffect(() => {
        PopulateData();
        GetComboData();
    }, [])

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    return <div >
        <Paper>
            <Grid container direction="row" style={{ marginTop: 10 }} >
                <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                    <BiztranControls.Input
                        label="Product"
                        id="Product"
                        onChange={(e) => setProduct(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                    <BiztranControls.Input
                        label="Customer"
                        id="Customer"
                        onChange={(e) => setCustomer(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                    <BiztranControls.Input
                        label="NC Number"
                        id="NcNumber"
                        onChange={(e) => setNcNumber(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                    <BiztranControls.Select
                        label="Created By"
                        id="SalesExecutiveID"
                        options={ComboSalesExecutive}
                        onChange={(e) => setSalesExecutiveID(e.target.value)}
                    />
                </Grid>
            </Grid>
            <Grid container direction="row" >
                <Grid item xs={12} sm={6} md={3} lg={2} xl={2} style={{ marginLeft: 7 }} >
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        style={{ width: "180px" }}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        style={{ width: "180px" }}
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </Grid>
                <Grid xs={6} md={4} sm={8} lg={4} xl={3} >
                    <div style={{ width: "100%", margin: 15 }} >
                        <div style={{ float: "left", width: "30%" }}>
                            <BiztranControls.Button
                                responsive="true"
                                text="Populate"
                                startIcon={<SearchIcon />}
                                onClick={() => {
                                    PopulateData();
                                }}
                            />
                        </div>
                        <div style={{ float: "left", marginTop: 15 }}>
                            <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
                        </div>
                        <div style={{ float: "left", paddingLeft: 10, width: "30%" }}>
                            {/* <Grid xs={12} sm={4} md={2} lg={2} xl={2} style={{ marginTop: 15 }}> */}
                            <BiztranControls.Button
                                responsive="true"
                                text="Add New"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => {
                                    handleOpenModal();
                                }}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>
            <BiztranControls.DataGrid
                rowHeight={25}
                headerHeight={34}
                rows={rows}
                columns={columns}
                checkboxSelection={false}
                autoHeight={true}
                Width="100%"
                components={{ Toolbar: CustomToolbar, }}
            />
        </Paper>
        <ModalFrame
            title="Nonconformance Report"
            maxWidth="md"
            isOpen={isOpen}
            setOpen={setOpen}
        >
            <CreateCustomerCompaints
                IssueTicketID={IssueTicketID}
                // Mode={Mode}
                Customer={Customer}
                setOpen={setOpen}
                PopulateData={PopulateData}
            />
        </ModalFrame>
    </div>
};

export default CustomerCompaints;